export default __webpack_public_path__ + "static/media/live_icon.d9d64739.svg";